require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-jennersdorf-sankt-martin-an-der-raab.json") })
        }
      }, "path---betreuungseinrichtungen-jennersdorf-sankt-martin-an-der-raab");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-jennersdorf-sankt-martin-an-der-raab!./.cache/json/betreuungseinrichtungen-jennersdorf-sankt-martin-an-der-raab.json
// module id = 920
// module chunks = 231608221292675